import React, { useContext, useState } from "react";
import { MyContext } from "./MyContext";
import { FeatureNotice } from "./featureAccess";
import { AdminSubscriptionReport } from "./adminSubscriptionReport";
import { AdminSubscriptionDueCharges } from "./adminSubscriptionDueCharges";
import { AdminSubscriptionPaymentFailures } from "./adminSubscriptionPaymentFailures";
import COLORS from "./styleConstants";

const views = [
  { id: "active", label: "Active Subscriptions" },
  { id: "due", label: "Due Charges" },
  { id: "failures", label: "Payment Failures" },
];

export const AdminSubscriptions = ({ initialView = "active" }) => {
  const { mystate } = useContext(MyContext);
  const [activeView, setActiveView] = useState(initialView);
  const canUseSubscriptions = [true, 1, "1", "true"].includes(
    mystate.farmDefaults?.can_use_subscriptions,
  );
  const visibleViews = views.filter(
    (view) => view.id !== "due" || canUseSubscriptions,
  );
  const selectedView =
    activeView === "due" && !canUseSubscriptions ? "active" : activeView;

  return (
    <div style={{ width: "100%", minWidth: 0 }}>
      <FeatureNotice
        featureKey="clientSubscriptions"
        farmDefaults={mystate.farmDefaults}
        prominent
      />
      <div
        role="tablist"
        aria-label="Subscription administration views"
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 4,
          borderBottom: `1px solid ${COLORS.lightblue}`,
          padding: "0 12px",
        }}
      >
        {visibleViews.map((view) => {
          const selected = selectedView === view.id;
          return (
            <button
              key={view.id}
              type="button"
              role="tab"
              id={`subscription-tab-${view.id}`}
              aria-selected={selected}
              aria-controls="subscription-tab-panel"
              onClick={() => setActiveView(view.id)}
              style={{
                padding: "10px 12px",
                border: "none",
                borderBottom: selected
                  ? `3px solid ${COLORS.blue}`
                  : "3px solid transparent",
                marginBottom: -1,
                background: "transparent",
                color: selected ? COLORS.blue : COLORS.textgrey,
                font: "inherit",
                fontWeight: selected ? 700 : 500,
                cursor: "pointer",
              }}
            >
              {view.label}
            </button>
          );
        })}
      </div>
      <div
        id="subscription-tab-panel"
        role="tabpanel"
        aria-labelledby={`subscription-tab-${selectedView}`}
        style={{ width: "100%", minWidth: 0 }}
      >
        {selectedView === "active" && <AdminSubscriptionReport />}
        {selectedView === "due" && canUseSubscriptions && (
          <AdminSubscriptionDueCharges />
        )}
        {selectedView === "failures" && <AdminSubscriptionPaymentFailures />}
      </div>
    </div>
  );
};
